export const SUPPORTED_CRMS = [
  'anva',
  'dias',
  'fasterforward',
  'assu',
  'brio_api',
];
